export const AppRoutes = {
  // Home
  home: "/",

  // Login
  login: "/login",
  privacyConsent: "/privacy-consent",
  logout: "/logout",
  resetPassword: "/reset-password",
  resetPasswordComplete: "/reset-password-complete",
  register: "/register",
  registerComplete: "/register-complete",
  confirmEmail: "/user-setting/confirm-email",

  // User Setting
  userSettingDetail: "/user-setting/detail",
  userSettingEdit: "/user-setting/edit",
  userSettingChangeEmail: "/user-setting/change-email",
  userSettingStudy: "/user-setting/study",

  // Bottom Nav Routes (placeholders)
  study: "/study",
  studySubject: "/study/:subjectId",
  studyDiagnosis: "/study/:subjectId/diagnosis",
  studyContents: "/study/:subjectId/contents",
  studyWordPractice: "/study/:subjectId/word-practice",
  studyWordQuiz: "/study/:subjectId/word-quiz",
  studyLevelPractice: "/study/:subjectId/level/:level/practice",
  studyLevelQuiz: "/study/:subjectId/level/:level/quiz",
  studyTextExplanation: "/study/:subjectId/text-explanation",
  vocabularyCategoryList: "/vocabulary-category",
  vocabularyDetail: "/vocabulary-category/vocabulary/:categoryName?",
  vocabularyPractice: "/vocabulary-category/vocabulary/:categoryName?/practice",
  vocabularyQuiz: "/vocabulary-category/vocabulary/:categoryName?/quiz",
  mockExam: "/mock-exam",
  mockExamDetail: "/mock-exam/:mockExamId",
  mockExamQuiz: "/mock-exam/:mockExamId/quiz",
  mockExamResult: "/mock-exam/result/:attemptId",
  more: "/more",
  license: "/more/license",
  contentProvider: "/more/content-provider",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Maintenance
  maintenance: "/maintenance",
};

export const LoginRoutes = [AppRoutes.login, AppRoutes.resetPassword, AppRoutes.register, AppRoutes.confirmEmail];

export const UserSettingRoutes = [
  AppRoutes.userSettingDetail,
  AppRoutes.userSettingEdit,
  AppRoutes.userSettingChangeEmail,
  AppRoutes.userSettingStudy,
];

export const BottomNavRoutes = [AppRoutes.study, AppRoutes.vocabularyCategoryList, AppRoutes.mockExam, AppRoutes.more];

export const ClientRoutes = [AppRoutes.home, ...UserSettingRoutes, ...BottomNavRoutes];
